
<template>
	<b-modal id="modal-copy" title="Export Notes">
		<span class="close" @click="onClose">
			<x-icon size="1.5x" class="custom-class"></x-icon>
		</span>
		<div class="">
			<div class="row">
				<div class="col-4">
					<div class="box">
						<b-button ref="container" @click="onCopyText" variant="primary">
							{{ copyText }}
						</b-button>
						<p>
							Perfect for pasting in notion.so, notepad, email clients, etc.
						</p>
					</div>
				</div>
				<div class="col-4">
					<div class="box">
						<b-button
							class="ml-3"
							ref="container"
							@click="onCopyHTML"
							variant="primary"
						>
							{{ copyHTML }}
						</b-button>
						<p>
							Best for pasting in wysiwyg editors. Eg: Wordpress texteditor.
						</p>
					</div>
				</div>
				<div class="col-4">
					<div class="box">
						<b-button ref="container" @click="onCopyCsv" variant="primary">
							{{ copyCsv }}
						</b-button>
						<p>Best for exporting to other services</p>
					</div>
				</div>
				<div class="col-12" v-if="hasReadwise">
					<div class="box">
						<h4>Integrations</h4>
						<article>
							<strong> Send to Readwise </strong>
							<p>Selected notes will be sent to your Readwise account</p>
							<button @click="send" class="btn btn-primary">Send</button>
						</article>
					</div>
				</div>
				<div class="col-12">
					<div class="box">
						<b-form-checkbox
							id="checkbox-1"
							v-model="options.removeLinks"
							name="checkbox-1"
							:value="true"
							:unchecked-value="false"
						>
							Remove links from notes?
						</b-form-checkbox>
						<b-form-checkbox
							id="checkbox-2"
							v-model="options.pageTitles"
							name="checkbox-2"
							:value="true"
							:unchecked-value="false"
						>
							Show page titles instead of domains?
						</b-form-checkbox>
					</div>
				</div>
			</div>
		</div>
		<h5>Preview</h5>
		<div class="preview" v-html="previewHTML"></div>
	</b-modal>
</template>

<script>
import { XIcon } from 'vue-feather-icons';
import tt from '@/lib/trim-text.js';
import Papa from 'papaparse';
export default {
	components: {
		XIcon,
	},
	data: function () {
		var obj = {
			lock: false,
			key: '',
			errorMessage: '',
			options: {},
			previewText: '',
			previewHTML: '',
			copyText: 'Copy Text',
			copyHTML: 'Copy HTML',
			copyCsv: 'Download CSV',
			options: {
				pageTitles: false,
				removeLinks: false,
			},
		};
		return obj;
	},
	watch: {
		options: {
			deep: true,
			handler: function () {
				this.generatePreviewHTML();
				this.generatePreviewText();
			},
		},
	},
	computed: {
		hasReadwise: function () {
			return this.$store.getters['user/hasReadwise'];
		},
		notes: function () {
			return this.$store.getters['note/notes'];
		},
		selectedNotes: function () {
			return this.$store.getters['note/selectedNotes'];
		},
		computedNotes: function () {
			let notes = this.notes;
			let selectedNotes = this.selectedNotes;
			let results = [];
			for (var i = 0; i < notes.length; i++) {
				if (selectedNotes.includes(notes[i].id)) {
					results.push(notes[i]);
				}
			}
			return results;
		},
		computedSites: function () {
			var grouped = _.groupBy(this.computedNotes, 'domain');
			var test = {};
			var keys = [];
			var count = 0;
			var title = '';
			for (var property in grouped) {
				if (grouped.hasOwnProperty(property)) {
					test = _.groupBy(grouped[property], 'ref');
					keys = Object.keys(test);
					count = grouped[property].length;
					title = property;
					if (grouped[property][0].meta) {
						title = grouped[property][0].meta.title || property;
					}
					if (!this.options.pageTitles) {
						title = property;
					}
					grouped[property] = {
						title: title,
						count: count,
						pages: test,
					};
				}
			}
			return grouped;
		},
	},
	methods: {
		onClose: function () {
			this.$bvModal.hide('modal-copy');
		},
		onCopyText: function () {
			this.$copyText(this.previewText, this.$refs.container);
			this.copyText = 'Copied';
			setTimeout(() => {
				this.copyText = 'Copy Text';
			}, 1000);
		},
		onCopyHTML: function () {
			this.$copyText(this.previewHTML, this.$refs.container);
			this.copyHTML = 'Copied';
			setTimeout(() => {
				this.copyHTML = 'Copy HTML';
			}, 1000);
		},
		onCopyCsv: function () {
			this.generateCSV(this.computedNotes);
		},
		send: function () {
			this.$store.dispatch('note/exportIntegration', 'readwise');
		},
		generateCSV: function (arr) {
			let row = [];
			let file = [];
			let filename = 'underlineme_export.csv';
			for (var i = 0; i < arr.length; i++) {
				row = [];
				row.push(arr[i].id);
				row.push(arr[i].text);
				row.push(arr[i].type);
				row.push(arr[i].href);
				row.push(arr[i].domain);
				row.push(arr[i].createdAt);
				if (arr[i].comment && arr[i].comment.raw) {
					row.push(arr[i].comment.raw);
				} else {
					row.push('');
				}
				file.push(row);
			}
			file = Papa.unparse(file);
			var blob = new Blob([file], { type: 'text/csv;charset=utf-8;' });
			if (navigator.msSaveBlob) {
				// IE 10+
				navigator.msSaveBlob(blob, filename);
			} else {
				var link = document.createElement('a');
				if (link.download !== undefined) {
					// feature detection
					// Browsers that support HTML5 download attribute
					var url = URL.createObjectURL(blob);
					link.setAttribute('href', url);
					link.setAttribute('download', filename);
					link.style.visibility = 'hidden';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			}
		},
		onSubmit: function () {
			this.lock = true;
			this.$store.dispatch('verify', { key: this.key }).then((res) => {
				if (res.status === 'success') {
					this.$router.push('guide');
					this.$bvModal.hide('modal-auth');
				} else {
					this.errorMessage = res.message;
				}
				this.lock = false;
			});
		},
		textToLink: function (text) {
			var str = '';
			str = str + '[' + text + '](' + 'https://' + text + ')';
			return str;
		},
		generatePreviewHTML: function () {
			let lineBreak = '<br />';
			let sites = this.computedSites;

			var str = '';
			for (var name in sites) {
				if (sites.hasOwnProperty(name)) {
					str = str + `<h3>${sites[name].title}</h3>`;
					str = str + '<ul>';
					for (var url in sites[name].pages) {
						if (sites[name].pages.hasOwnProperty(url)) {
							sites[name].pages[url].map((note) => {
								str = str + '<li><span>' + note.text + '</span>';
								if (note.comment && note.comment.html) {
									str = str + lineBreak + '<em>' + note.comment.html + '</em>';
								}
								if (!this.options.removeLinks) {
									str = `${str} ${lineBreak} <a href="${note.href}">${note.href}</a>`;
								}
								str = str + '</li>';
							});
						}
					}
					str = str + '</ul>' + lineBreak;
				}
			}

			str = str + '';

			this.previewHTML = str;
		},
		generatePreviewText: function () {
			let lineBreak = '\n';
			let sites = this.computedSites;

			var str = '';
			for (var name in sites) {
				if (sites.hasOwnProperty(name)) {
					str = str + 'https://' + name + lineBreak;
					for (var url in sites[name].pages) {
						if (sites[name].pages.hasOwnProperty(url)) {
							sites[name].pages[url].map((note) => {
								str = str + '- ' + note.text + lineBreak;
								if (note.comment && note.comment.raw) {
									str = str + ' ' + note.comment.raw + lineBreak;
								}
								if (!this.options.removeLinks) {
									str = `${str} ${note.href}`;
								}
								str = str + lineBreak;
							});
						}
					}
					str = str + lineBreak;
				}
			}

			str = str + '';

			this.previewText = str;
		},
		init: function () {
			this.generatePreviewHTML();
			this.generatePreviewText();
		},
	},
	mounted: function () {
		this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
			this.init();
		});
	},
};
</script>

<style lang="scss">
#modal-copy___BV_modal_outer_ {
	.modal-dialog {
		max-width: 720px;
	}
	.modal-content {
		ul {
			list-style: initial;
		}
		h3 {
			margin-bottom: 1rem;
		}

		.box {
			margin-bottom: 1rem;
			padding: 0.5rem;
			border-radius: 12px;
			background-color: rgba(0, 0, 0, 0.3);
			.btn {
				margin-bottom: 0.25rem;
			}

			p {
				opacity: 0.85;
				font-size: 0.825rem;
				margin-bottom: 0;
			}
		}

		.preview {
			font-size: 14px;
			margin-top: 0.5rem;
			padding: 1rem;
			border-radius: 7px;
			background-color: rgba(0, 0, 0, 0.2);
			font-feature-settings: 'case' 0, 'cpsp' 0, 'dlig' 0, 'frac' 0, 'dnom' 0,
				'numr' 0, 'salt' 0, 'subs' 0, 'sups' 0, 'tnum', 'zero' 0, 'ss01' 0,
				'ss02' 0, 'ss03' 0, 'ss04' 0, 'cv01' 0, 'cv02' 0, 'cv03' 0, 'cv04' 0,
				'cv05' 0, 'cv06' 0, 'cv07' 0, 'cv08' 0, 'cv09' 0, 'cv10' 0, 'cv11' 0,
				'calt', 'kern';

			h3 {
				font-size: 1.35em;
				margin-bottom: 0.5rem;
			}

			em {
				display: inline-block;
				opacity: 0.85;

				p {
					margin-bottom: 0;
				}
			}
		}

		.logo {
			max-width: 200px;
			margin-bottom: 1rem;
		}
		.spinner-border {
			vertical-align: baseline;
			display: inline-block;
			width: 2rem;
			height: 2rem;
			border: 0.25em solid;
			border-right: 0.25em solid transparent;
			border-radius: 50%;
			animation: spinner-border 0.75s linear infinite;
		}
		.spinner-border-sm {
			width: 12px;
			height: 12px;
			border-width: 2px;
		}

		@keyframes spinner-border {
			to {
				-webkit-transform: rotate(1turn);
				transform: rotate(1turn);
			}
		}
	}
}
</style>